import { atomFamily } from 'recoil'

import { MarketDataSnapshot } from 'types/api/market-data-snapshot'

export const marketDataSnapshots = atomFamily<MarketDataSnapshot, string>({
  key: 'marketDataSnapshots',
  default: null,
})
